import React, { useEffect, useState } from 'react';
import {
  Container, Row, Col, Button, Spinner,
} from 'react-bootstrap';
import axios from 'axios';
import { useHistory, useParams } from 'react-router-dom';
import { Content } from '../styles';
import { Loader } from '../../../Superadmin/TambahAdmin/styles';
import UnifyButton from '../../../../components/Button';
import config from '../../../../config';
import Navbar from '../../../../components/Navbar';
import Header from '../../../../components/Header';
import Atribut from './atribut';
import ModalSetuju from './ModalSetuju';
import ModalTolak from './ModalTolak';

const DetailApproval = () => {
  const history = useHistory();
  const { idProgres } = useParams();
  const [loading, setLoading] = useState(true);
  const [showSetuju, setShowSetuju] = useState(false);
  const [showTolak, setShowTolak] = useState(false);
  const [content, setContent] = useState({
    deskripsi: '',
    jabatan: '',
    kum_id: {
      biaya: '',
      image_url: '',
      jenis_kegiatan: '',
      link_regis: '',
      lokasi: '',
      moderator: '',
      nama_kegiatan: '',
      nilai_kum: '',
      pembicara: '',
      penyelenggara: '',
      pukul: '',
      sertifikat: '',
      tanggal: '',
    },
    mahasiswa: {
      prodi: '',
      user: {
        name: '',
        username: '',
      },
    },
    nama_organisasi: '',
    no_telepon: '',
    proposal: '',
    status: '',
    feedback: '',
  });

  useEffect(() => {
    axios.get(`${config.API_BASE_URL}api/pengajuan_kuliah_umum/detail/${idProgres}/`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      ({ data }) => {
        const tempData = data;
        if (tempData.kum_id.biaya) {
          tempData.kum_id.biaya = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(data.kum_id.biaya);
        }
        setContent(tempData);
      },
    );
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }

  return (
    <>
      <Navbar />
      <Header />
      <Content>
        <Container className="container-list mb-5 mt-3">
          <UnifyButton
            color="#F9B114"
            textColor="#373736"
            className="font-20 btn-kembali"
            onClick={() => history.goBack()}
          >
            {'\u2190 Kembali'}
          </UnifyButton>
          <h1 className="text-center mb-2 font-32">Detail Progres Pengajuan Kegiatan KUM</h1>
          <Row className="mt-5 ml-1 mr-1">
            <Col className="mr-1">
              <Atribut nama="Nama Pengaju" data={content.mahasiswa.user.name} />
              <Atribut nama="Prodi" data={content.mahasiswa.prodi} />
              <Atribut nama="Email" data={`${content.mahasiswa.user.username}@ui.ac.id`} />
              <Atribut nama="Jabatan" data={content.jabatan} />
              <Atribut nama="Nama Kegiatan" data={content.kum_id.nama_kegiatan} />
              <Atribut nama="Hari/Tanggal" data={content.kum_id.tanggal} />
              <Atribut nama="Biaya" data={content.kum_id.biaya} />
              <Atribut nama="Moderator" data={content.kum_id.moderator} />
              <Atribut nama="Sertifikat" data={content.kum_id.sertifikat} />
              <Atribut nama="Status" data={content.status} />
            </Col>
            <Col className=" ml-1">
              <Atribut nama="NPM" data={content.mahasiswa.user.npmnip} />
              <Atribut nama="Badan Organisasi" data={content.nama_organisasi} />
              <Atribut nama="No Telepon" data={content.no_telepon} />
              <div className="detail-atribut justify-content-between">
                <h4 className="font-24">Proposal</h4>
                <p className="font-20"><a href={content.proposal} className="link-proposal">Proposal</a></p>
              </div>
              <Atribut nama="Jenis Kegiatan" data={content.kum_id.jenis_kegiatan} />
              <Atribut nama="Pukul" data={content.kum_id.pukul} />
              <Atribut nama="Lokasi" data={content.kum_id.lokasi} />
              <Atribut nama="Pembicara" data={content.kum_id.pembicara} />
              <Atribut nama="Deskripsi" data={content.deskripsi} />
              <Atribut nama="Feedback" data={content.feedback} />
            </Col>
          </Row>
          {
            content.status === 'menunggu persetujuan'
            && (
              <Row className="mt-2">
                <Col className="text-center">
                  <Button
                    className="btnAction btn-primary mr-2 font-20"
                    variant="danger"
                    onClick={() => setShowTolak(true)}
                    data-testid="tolak"
                  >
                    Tolak
                  </Button>
                  <Button
                    className="btnAction btn-primary font-20"
                    variant="success"
                    onClick={() => setShowSetuju(true)}
                    data-testid="setuju"
                  >
                    Setuju
                  </Button>
                </Col>
                <ModalSetuju
                  id={content.id}
                  show={showSetuju}
                  onHide={() => setShowSetuju(false)}
                  history={history}
                />
                <ModalTolak
                  id={content.id}
                  show={showTolak}
                  onHide={() => setShowTolak(false)}
                  history={history}
                />
              </Row>
            )
          }
        </Container>
      </Content>
    </>
  );
};

export default DetailApproval;
